import type { Story } from '@/store/story-types'

export const PROXY_BUYING_CATALOG_STORY: Story = {
  id: 'proxy-buying-catalog',
  name: 'KShop Global — Korean Proxy Buying',
  narrative: 'A Korean proxy buying catalog with fee transparency, multilingual support, real-time exchange rates, and a streamlined request-to-delivery flow.',
  goals: ['Browse Korean products', 'Calculate proxy fees', 'Request proxy purchase', 'Track order delivery'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Landing page with hero, product catalog grid, and fee calculator',
      blockRef: { category: 'k-commerce', blockId: 'proxy-hero' },
    },
    {
      id: 'pg-product-detail', title: 'Product Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'product-detail',
      description: 'Product detail with proxy fee breakdown and request button',
      blockRef: { category: 'k-commerce', blockId: 'product-detail-proxy' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart view with consolidated proxy fees and checkout',
      blockRef: { category: 'k-commerce', blockId: 'proxy-cart-view' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Catalog',
      description: 'Visitor browses the Korean product catalog',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero section and product catalog grid with prices in local currency are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Calculate Proxy Fee',
      description: 'Visitor calculates total cost including proxy and shipping fees',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'they use the fee calculator' },
        { type: 'then', text: 'the estimated total with proxy fee, shipping, and exchange rate is displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Request Proxy Purchase',
      description: 'Visitor requests a proxy purchase for a specific product',
      steps: [
        { type: 'given', text: 'the visitor is on the product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap the Request Proxy Buy button' },
        { type: 'then', text: 'the item is added to the cart with fee breakdown', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Checkout with Proxy Order',
      description: 'Visitor completes checkout for proxy-bought items',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout' },
        { type: 'then', text: 'a summary with item costs, proxy fees, and shipping estimate is shown' },
        { type: 'and', text: 'the order is submitted for proxy fulfillment', linkedFlowId: 'submitProxyOrder' },
      ],
    },
  ],
}
